import React, { useRef, useEffect } from 'react';
import {Video as RNVideo} from 'react-native-video';
import type { ReactVideoProps } from 'react-native-video/lib/types';

const Video = (props: ReactVideoProps) => {

  // this is a fix because
  // react-native-video DOES NOT currently support crossorigin attribute for web
  const videoRef = useRef(null);
  useEffect(() => {
    if (videoRef.current) {
      // @ts-ignore
      const htmlVideoEl = videoRef.current.nativeHtmlVideoRef.current;
      if (htmlVideoEl) {
        htmlVideoEl.setAttribute('crossorigin', 'true');
      }
    }
  }, []);

  return <RNVideo ref={videoRef} {...props} />;
};

export default Video;